import { createElement, type ReactNode, useState } from 'react'

interface SheetPortalHost {
  container: HTMLElement | undefined
  hostNode: ReactNode
}

/** In-sheet portal target for Popover / DropdownMenu content: a Sheet's scroll
    lock cancels touch scrolling inside anything portaled to `document.body`. */
export function useSheetPortalHost(insideSheet: boolean): SheetPortalHost {
  const [host, setHost] = useState<HTMLElement | null>(null)
  return {
    container: insideSheet ? (host ?? undefined) : undefined,
    hostNode: insideSheet ? createElement('div', { ref: setHost }) : null,
  }
}
